import styled from '@emotion/styled';
import { Button } from 'src/web/components/Buttons/Button/Button';
import { IconButton } from 'src/web/components/Buttons/IconButton/IconButton';
import { OL_COLOUR_BLACK_4 } from 'src/web/components/Style/colours';

export const BackgroundTaskWrapper = styled('div')({
  background: OL_COLOUR_BLACK_4,
  borderRadius: '4px',
  padding: 16,
  margin: '20px 0',
});

export const StyledButton = styled(Button)({
  float: 'right',
  marginTop: -8,
  marginLeft: 8,
});

export const StyledIconButton = styled(IconButton)({
  float: 'right',
  marginTop: -8,
  marginLeft: 8,
});

export const ErrorInfoWrapper = styled('div')({
  marginLeft: 28,
});

export const IconWrapper = styled('span')({
  marginRight: 16,
});
